<template>
  <v-container fluid>
    <!-- some comments updated -->
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Account Balances</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-2">
          <v-btn color="primary" small @click="openFinancialYear" :loading="loader">
            <v-icon left dark>mdi-</v-icon>Open Financial Year
          </v-btn>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="8">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>

            <!-- start of table -->
            <v-data-table
              :items-per-page="200"
              :mobile-breakpoint="zeroValue"
              :headers="headers"
              :items="accounts"
              :search="search"
            >
              <!-- category template -->
              <template v-slot:item.category="{ item }">
                <span v-if="item.category">{{item.category.Name}}</span>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>
  
  <script>
export default {
  data: () => ({
    search: "",
    loader: false,
    zeroValue: 0,
    headers: [
      { text: "Account Name", value: "Account.Name" },
      { text: "Balance", value: "amount" }
    ],
    accounts: []
  }),
  methods: {
    getAccountBalances() {
      const self = this;
      this.$store
        .dispatch("get", `/account-balances`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    openFinancialYear() {
      this.loader = true;
      const self = this;
      this.$store
        .dispatch("get", `/open-financial-year`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            this.$refs.snackbar.show(
              "Financial year opened successfully",
              "green"
            );
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getAccountBalances();
  }
};
</script>